import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader, ContentCustom } from '../../components';
import ProductTab from './ProductTab';

const DocumentLibrary = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('document_library.title')} />
      <ContentCustom>
        <ProductTab />
      </ContentCustom>
    </>
  );
};

export default DocumentLibrary;
